import React, { useEffect, useState } from "react";
import "../../components/SharedComponents/Styles/SharedGenericStyles.css";

const ReferralMessagePage = ({
    caseID,
    checkIcon,
    assessmentValue,
    setAssessmentValue,
    treatmentValue,
    setTreatmentValue,
    referralMessageStatus,
    notesToAPHandler,
    noteLength,
    selectedClinic,
    notesToAP,
    messageMaxCharLength,
    setLoaderMessage,
    setReferralMessageOverlay,
    ReferralMessageOverlay,
    setJustification,
    justification,
    availableCaseDocuments,
    api,
    selectedSlot,
    onBack,
    onClose,
}) => {
    const [availableDocuments, setAvailableDocuments] = useState(availableCaseDocuments);
    const [selectedDocuments, setSelectedDocuments] = useState([]);
    const [makeReferralResult, setmakeReferralResult] = useState(null);
    const [loader, setLoader] = useState(false);
    const [caseDocumentsToSend, setCaseDocumentsToSend] = useState([]);
    const [gender, setGender] = useState("");
    const [saveStatus, setSaveStatus] = useState(false);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);

    let patientID;

    useEffect(() => {
        setCaseDocumentsToSend(selectedDocuments);
    }, [selectedDocuments]);

    useEffect(() => {
        setAvailableDocuments((prev) =>
            [...prev].sort((a, b) => a.DocumentUploadID - b.DocumentUploadID)
        );
    }, [availableDocuments]);

    const handleSelectDocument = (id) => {
        const selectedOption = availableCaseDocuments.find((opt) => opt.DocumentUploadID === id);
        if (selectedOption) {
            setAvailableDocuments((prev) =>
                prev.filter((opt) => opt.DocumentUploadID !== id)
            );
            setSelectedDocuments((prev) => [...prev, selectedOption]);
        }
    };

    const handleRemoveDocument = (id) => {
        const removed = selectedDocuments.find((opt) => opt.DocumentUploadID === id);
        if (removed) {
            setSelectedDocuments((prev) =>
                prev.filter((opt) => opt.DocumentUploadID !== id)
            );
            setAvailableDocuments((prev) => [...prev, removed]);
        }
    };

    const backToPatientBoard = (e) => {
        e.preventDefault();
        window.location.replace("/Presentation/Page/PMS/CaseInVoicePage.aspx?CaseID=" + caseID);
    };

    const makeReferral = async (e) => {
        e.preventDefault();
        setLoader(true);
        setLoaderMessage("");
        setSaveStatus(false);
        setShowSuccessPopup(false);

        const params = {
            notesToAP,
            CaseID: caseID,
            FacilityID: selectedClinic.pkFacilityID?.toString(),
            PatientID: patientID,
            Assessment: assessmentValue,
            Treatment: treatmentValue,
            Gender: gender,
            Justification: justification,
            CaseDocuments: caseDocumentsToSend,
            SelectedSlot: selectedSlot,
            Flag: "PharosChooseAndBook",
            FirstAppointmentDate: selectedClinic.FirstAppointment?.toString(),
        };

        try {
            const r = await api.transact("MakeReferral", params);
            console.log("Referral response:", r);

            setLoader(false);
            setLoaderMessage(r.apiText);

            if (r.apiStatus === "OK") {
                setmakeReferralResult(r.apiText);
                setSaveStatus(true);
                setShowSuccessPopup(true);
            } else {
                setSaveStatus(false);
                setmakeReferralResult(r.apiText || "Error occurred");
            }
        } catch (e) {
            console.error("Referral error:", e);
            setLoader(false);
            setSaveStatus(false);
            setmakeReferralResult(e.apiText || "Unexpected error");
        }
        finally {
            setLoader(false);
        }
    };

    return (
        <div className="referralMessagePageContainer">
            <div className="referralMessageBoardContent">
                <label className="inputField">
                    <span className="inputLabel">Clinic</span>
                    <span className="inputControl">{selectedClinic?.FacilityName || ""}</span>
                </label>

                <label className="inputField">
                    <span className="inputLabel">Notes to AP</span>
                    <textarea
                        className="inputControl"
                        value={notesToAP}
                        onChange={notesToAPHandler}
                        maxLength={messageMaxCharLength}
                        rows={6}
                    />
                    <span className="charCount">
                        {noteLength}/{messageMaxCharLength}
                    </span>
                </label>

                <label className="inputField">
                    <span className="inputLabel">
                        Available Case Documents
                    </span>
                    <select
                        className="inputControl"
                        onChange={(e) => handleSelectDocument(parseInt(e.target.value))}
                    >
                        <option value="">Select a document</option>
                        {availableDocuments.map((doc) => (
                            <option key={doc.DocumentUploadID} value={doc.DocumentUploadID}>
                                {doc.Name}
                            </option>
                        ))}
                    </select>
                </label>

                {selectedDocuments.length > 0 && (
                    <div className="inputField">
                        <span className="inputLabel">Selected Case Documents</span>
                        <ul className="selectedDocumentsList">
                            {selectedDocuments.map((doc) => (
                                <li key={doc.DocumentUploadID}>
                                    <span>{doc.Name}</span>
                                    <button
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleRemoveDocument(doc.DocumentUploadID);
                                        }}
                                    >
                                        Remove
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                <label className="inputField">
                    <span className="inputLabel">Assessment</span>
                    <select
                        className="inputControl"
                        value={assessmentValue}
                        onChange={(e) => setAssessmentValue(e.target.value)}
                    >
                        {[...Array(11).keys()].map((num) => (
                            <option key={num} value={num}>
                                {num}
                            </option>
                        ))}
                    </select>
                </label>

                <label className="inputField">
                    <span className="inputLabel">Treatment</span>
                    <select
                        className="inputControl"
                        value={treatmentValue}
                        onChange={(e) => setTreatmentValue(e.target.value)}
                    >
                        {[...Array(11).keys()].map((num) => (
                            <option key={num} value={num}>
                                {num}
                            </option>
                        ))}
                    </select>
                </label>

                {selectedClinic?.ClosestIndex === true && (
                    <label className="inputField">
                        <span className="inputLabel">
                            Justification <span style={{ color: "red" }}>(Required)</span>
                        </span>
                        <select
                            className="inputControl"
                            value={justification}
                            onChange={(e) => setJustification(e.target.value)}
                        >
                            <option value="">Select justification</option>
                            <option value="Patient Request - Distance">Patient Request - Distance</option>
                            <option value="Patient Request - Clinic hours">Patient Request - Clinic hours</option>
                            <option value="Patient Request - Personal recommendation">
                                Patient Request - Personal recommendation
                            </option>
                            <option value="Client Request">Client Request</option>
                            <option value="No PPS Available">No PPS Available</option>
                            <option value="No OPM Available">No OPM Available</option>
                            <option value="Clinical Reason">Clinical Reason</option>
                        </select>
                    </label>
                )}

                {makeReferralResult && (
                    <p className="makeReferralResultErrorMessage">
                        {makeReferralResult} - {referralMessageStatus || ""}
                    </p>
                )}
                <button className="saveButton" onClick={makeReferral} disabled={loader}>
                    {loader ? "Saving..." : "Save"}
                </button>
            </div>

            {showSuccessPopup && (
                <div className="popupCBOverlay">
                    <div className="popupCBBox">
                        <img src={checkIcon} className="SuccessMessageIcon" alt="Success Icon" />
                        <p className="SuccessMessageText">Make Referral Successful!</p>
                        <button className="onwardReferralCBSaveButton" onClick={backToPatientBoard}>
                            Go to service charge page
                        </button>

                    </div>
                </div>
            )}
        </div>
    );
};

export default ReferralMessagePage;
